/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type BackorderStatus = "CLOSED" | "FULFILLED" | "OPEN" | "PARTIALLY_FULFILLED";
import type { FragmentReference } from "relay-runtime";
declare export opaque type BackordersTable_backorderEdges$ref: FragmentReference;
declare export opaque type BackordersTable_backorderEdges$fragmentType: BackordersTable_backorderEdges$ref;
export type BackordersTable_backorderEdges = $ReadOnlyArray<{|
  +node: {|
    +id: string,
    +backorderNumber: string,
    +status: BackorderStatus,
    +expectedDate: ?any,
    +notes: ?string,
    +order: {|
      +id: string,
      +orderNumber: string,
    |},
    +customer: {|
      +id: string,
      +name: string,
    |},
    +createdAt: any,
    +updatedAt: any,
  |},
  +$refType: BackordersTable_backorderEdges$ref,
|}>;
export type BackordersTable_backorderEdges$data = BackordersTable_backorderEdges;
export type BackordersTable_backorderEdges$key = {
  +$data?: BackordersTable_backorderEdges$data,
  +$fragmentRefs: BackordersTable_backorderEdges$ref,
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "BackordersTable_backorderEdges",
  "type": "BackorderEdge",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "node",
      "storageKey": null,
      "args": null,
      "concreteType": "Backorder",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "backorderNumber",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "status",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "expectedDate",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "notes",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "order",
          "storageKey": null,
          "args": null,
          "concreteType": "Order",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "orderNumber",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "customer",
          "storageKey": null,
          "args": null,
          "concreteType": "Customer",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "name",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "createdAt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "updatedAt",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '9ad6e267374b89d0c4bcb6436f0e4095';
module.exports = node;
